export const shouldUseFreeTextAddressField = (
    parentIsSelected: boolean,
    items: string[],
    queryCalled: boolean,
    queryLoading: boolean,
): boolean => parentIsSelected && queryCalled && !queryLoading && items.length === 0
